import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon29: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M9.5 0.5V2.5C9.5 2.776 9.724 3 10 3C10.276 3 10.5 2.776 10.5 2.5V0.5C10.5 0.224 10.276 0 10 0C9.724 0 9.5 0.224 9.5 0.5ZM9.5 17.5V19.5C9.5 19.776 9.724 20 10 20C10.276 20 10.5 19.776 10.5 19.5V17.5C10.5 17.224 10.276 17 10 17C9.724 17 9.5 17.224 9.5 17.5ZM0.5 10.5H2.5C2.776 10.5 3 10.276 3 10C3 9.724 2.776 9.5 2.5 9.5H0.5C0.224 9.5 0 9.724 0 10C0 10.276 0.224 10.5 0.5 10.5ZM17.5 10.5H19.5C19.776 10.5 20 10.276 20 10C20 9.724 19.776 9.5 19.5 9.5H17.5C17.224 9.5 17 9.724 17 10C17 10.276 17.224 10.5 17.5 10.5ZM20 10C20 4.477 15.523 0 10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10ZM19 10C19 14.971 14.971 19 10 19C5.029 19 1 14.971 1 10C1 5.029 5.029 1 10 1C14.971 1 19 5.029 19 10ZM14.703 4.61099C14.902 4.50099 15.143 4.53999 15.297 4.69299C15.453 4.84999 15.493 5.09199 15.382 5.29099L11.851 11.651C11.821 11.707 11.781 11.754 11.736 11.792C11.711 11.811 11.685 11.829 11.656 11.845L11.717 11.806C11.699 11.82 11.68 11.833 11.66 11.844L5.297 15.377C4.858 15.621 4.374 15.137 4.618 14.697L8.149 8.33701C8.151 8.33201 8.154 8.328 8.157 8.323C8.163 8.314 8.169 8.30499 8.175 8.29599C8.183 8.28199 8.193 8.27 8.203 8.258C8.211 8.249 8.219 8.23999 8.228 8.23099C8.261 8.19599 8.299 8.16799 8.339 8.14499L14.703 4.61099ZM8.7 9.401L6.341 13.654L10.591 11.292L8.7 9.401ZM13.659 6.33499L9.409 8.69601L11.299 10.586L13.659 6.33499Z"
        fill="#32BBC3"
      />
    </Icon>
  )
}
